import React, { createContext, useContext, useEffect, useState } from "react";
import { track } from "../lib/api";

const CartCtx = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    const raw = localStorage.getItem("ti_cart");
    return raw ? JSON.parse(raw) : [];
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("ti_cart", JSON.stringify(items));
  }, [items]);

  const add = (item) => {
    // fire-and-forget tracking
    if (item.product_type && item.product_id) {
      track(item.product_type, item.product_id, "cart_add");
    }
    setItems((prev) => {
      const existing = prev.find(
        (x) => x.product_id === item.product_id && x.unit === (item.unit || "pz")
      );
      if (existing) {
        return prev.map((x) =>
          x === existing ? { ...x, quantity: x.quantity + (item.quantity || 1) } : x
        );
      }
      return [...prev, { ...item, unit: item.unit || "pz", quantity: item.quantity || 1 }];
    });
    setOpen(true);
  };

  const addMany = (list) => list.forEach(add);

  const remove = (product_id, unit = "pz") => {
    setItems((prev) => prev.filter((x) => !(x.product_id === product_id && x.unit === unit)));
  };

  const setQty = (product_id, unit, qty) => {
    setItems((prev) =>
      prev.map((x) => (x.product_id === product_id && x.unit === unit ? { ...x, quantity: Math.max(1, qty) } : x))
    );
  };

  const clear = () => setItems([]);

  const subtotal = items.reduce((s, x) => s + x.unit_price * x.quantity, 0);
  const count = items.reduce((s, x) => s + x.quantity, 0);

  return (
    <CartCtx.Provider value={{ items, add, addMany, remove, setQty, clear, subtotal, count, open, setOpen }}>
      {children}
    </CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
